import { gql } from '@apollo/client';

export const DELETE_RECIPE = gql`
  mutation DeleteRecipe($recipeId: String!) {
    deleteRecipe(recipeId: $recipeId)
  }
`;